<template>
	<div class="login">
		<p class="head_title">
			布克de奇幻世界
		</p>
		<p>
			<label> <span class="red">*</span>账号:
				<input type="text" :value="userID" @input="check($event.target.value,'uid')" maxlength="16"
					placeholder="请输入账号(6-16位)" />
			</label>
		</p>
		<p>
			<label><span class="red">*</span>密码:
				<input type="password" :value="pwd" @input="check($event.target.value,'pwd')"
					placeholder="请输入密码(6-16位)" />
			</label>
		</p>
		<p>
			<!-- <label>店铺:
				<select v-model="shopid">
					<option v-for="(i,index) in shop" :value="i.ShopID">
						{{i.ShopName}}
					</option>
				</select>
			</label> -->
		</p>
		<p class="message">
			<span class='err'>{{mes}}</span>
		</p>
		<p>
			<input type="button" :disabled="!checkLogin" maxlength="16" @click="login" value="登录"
				class="button login_button" />
		</p>
		<div style="width: 100%;left: 0px;position:absolute;bottom:0px;text-align:center;padding-bottom:10px">
			<a href="https://beian.miit.gov.cn" target="_blank"
				style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px;">
				<span style="color:#939393"> 鄂ICP备2021017427号-1</span></a>
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42030202000753"
				style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px;">
				<img src='../../assets/img/beian/beian.png' style="vertical-align:middle" />
				<p
					style="display:inline-block; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #939393;">
					鄂公网安备
					42030202000753号</p>
			</a>
		</div>
	</div>

</template>

<script>
	import {
		request
	} from '@/networks/request.js'
	export default {
		name: 'login',
		data() {
			return {
				userID: '',
				pwd: '',
				checkLogin: false,
				shopid: '',
				shop: '',
				mes: ''

			}
		},
		beforeCreate() {

		},

		created() {
			this.mes = '初始化....';
			this.$request.get({
				url: '/config.json'
			}).then(r => {
				this.$store.commit('saveUrl', r);
			 
				this.mes='初始化完成';
				// this.$request.request({
				// 	url: 'login/getshop',
				// 	data: {},
				// 	method: 'get'
				// }).then(data => {
				// 	this.mes='初始化完成'
				// 	this.shop = data.shop;
				// 	this.shopid = data.shop[0].ShopID;
				// })
			});

		},
		computed: {

		},
		methods: {
			login() {
				this.$request.request({
					url: 'login/login',
					data: {
						'UserAccount': this.userID,
						'UserPassWorld': this.pwd
						//'ShopID': this.shopid
					},
					method: 'post'
				}).then(data => {
					if (data.UserID == 0) {
						this.mes = data.message;
					} else {
						if (data.UserState == 0) {
							this.$store.commit('saveUser', data);
							//this.$store.commit('setShop', {
							//	shopID: this.shopid,
							//});
							this.$store.dispatch('refresh');
							this.$router.replace('home');
						} else
							this.mes = '该账户已经停用!';
					}

				}).catch(err => {
					this.mes = '账号或者密码错误!';
				});
			},
			check(value, s) {
				this.mes = '';
				this.checkLogin = true;
				if (s == 'uid')
					this.userID = value;
				else
					this.pwd = value;
				if (!this.$uil.checkstr(this.userID, 6, 16)) {
					this.checkLogin = false;
					this.mes = "账号不符合规则";
				}
				if (!this.$uil.checkstr(this.pwd, 6, 16)) {
					this.checkLogin = false;
					this.mes = "密码不符合规则";
				}
			}


		}

	}
</script>
<style>
	.login{
		box-shadow: 0px 0px 10px 2px #cfcfcf;
		background-image: linear-gradient(to top,#d4e7ff,white);
	}
	.login-button:hover {
		/* 鼠标移入按钮范围时改变颜色 */
		background: #5599FF;
	}

	.login>P {
		text-align: center;
		padding: 1rem;
	}

	.message {
		height: 1rem;
	}

	.head_title {
		letter-spacing: 0.2rem;
		font-size: 1.5rem;
		height: 2.5rem;
		line-height: 2.5rem;
	}
</style>
